import { Navigate } from "react-router-dom";
import { useAuth } from "@/services/auth";
import type { FC, PropsWithChildren } from "react";

export const ProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/auth/log-in" replace />;
  }

  return <>{children}</>;
};
